import useActionsCustomerAdvancedForm from './useActionsCustomerAdvancedForm'

export default useActionsCustomerAdvancedForm
